export default (value) => {
  return parseInt(value)
}



// WEBPACK FOOTER //
// ./src/filters/tofixedzero.js